<template>
    <section class="account">
        <div class="row">
            <div class="col pr-0 text-center">
                 <!-- 
                  <div v-if="editable" class="upload-btn-wrapper">
                    <button><img src="img/ico-camera.svg"></button>
                    <input type="file" name="myfile" @change="onFileSelected"> 
                  </div>
                -->
                <img v-if="!editing" v-bind:src="imgSrc" class="rounded-circle img-fluid">

                <div v-if="editable">
                  <croppa 
                    v-if="editing"
                    v-model="myCroppa" 
                    :width="165"
                    :height="165"
                    :placeholder-font-size="10"
                    prevent-white-space
                    @init="onInit"
                    :show-remove-button="false"
                  >
                    <!-- <img slot="placeholder" src="img/ico-camera.svg"> -->
                  </croppa>
                  <b-button v-if="!editing" size="sm" @click="changeImage">Change Picture</b-button>
                  <b-button v-if="editing" size="sm" @click="onConfirm">Confirm</b-button>
                </div>

            </div>
            <div class="col d-flex justify-content-center flex-column">
                <h2 class="font-italic">
                    <small>Hello,</small>
                    {{ name }}
                </h2>
                <h2 class="font-italic">
                  <small>Policy Number</small>
                  {{ policyNumber }}
                </h2>
            </div>
        </div>
    </section>    
</template>

<script>

import api from '../http/api.js';

export default {
  name: 'UserPreview',
  props: {
    editable: {
        type: Boolean,
        default: false
    } 
  },
  data: function () {
    return {
      selectedFile: null,
      editing: false,
      myCroppa: {}
    }
  },
  computed: {
    /* infos () {
      //console.log("infos", this.$store.state.userInfo);
      return this.$store.state.userInfo;
    }, */
    name (){
      return this.$store.state.userInfo.name;
    },
    policyNumber (){
      return this.$store.state.userInfo.policyNumber;
    },
    imgSrc () {
      if(this.$store.state.userInfo.img != null){
        return 'https://strategicadigital.com/storage/'+ this.$store.state.userInfo.img;
      } else {
        return 'img/photo-placeholder.png';
      }
    }
  },
  methods: {
    changeImage(){
      this.editing = true;
    },
    // croppa init only if editing = true
    onInit() {
      this.myCroppa.addClipPlugin(function (ctx, x, y, w, h) {
        /*
         * ctx: canvas context
         * x: start point (top-left corner) x coordination
         * y: start point (top-left corner) y coordination
         * w: croppa width
         * h: croppa height
        */
        ////console.log(x, y, w, h)
        ctx.beginPath()
        ctx.arc(x + w / 2, y + h / 2, w / 2, 0, 2 * Math.PI, true)
        ctx.closePath()
      });

      this.myCroppa.chooseFile(); // default open browse file
    },
    onConfirm(){
      const self = this;
      this.myCroppa.generateBlob(
        blob => {
          // write code to upload the cropped image file (a file is a blob)

          const fd = new FormData();
          fd.append('image', blob);

          api.post('/v1/me-pic', fd)
            .then((resp) => {
              //console.log("success", resp);
              this.$store.dispatch('setImg', resp.data);
              self.editing = false;              
            })
            .catch(() => {
              //console.log("error", err);
            });

        },
        'image/jpeg',
        0.8
      ); // 80% compressed jpeg file
    },
    
    /* 
    handleCroppaFileChoose(){
      //console.log("handleCroppaFileChoose");
    },
    handleCroppaFileSizeExceed(){
      //console.log("handleCroppaFileSizeExceed");

    },
    handleCroppaFileTypeMismatch(){
      //console.log("handleCroppaFileTypeMismatch");
    },
    handleNewImage(){
      //console.log("handleNewImage");
    },
    handleImageRemove(){
      //console.log("handleImageRemove");
    },
    handleCroppaMove(){
      //console.log("handleCroppaMove");
    },
    handleCroppaZoom(){
      //console.log("handleCroppaZoom");
    }, */
  }
}
</script>
